export type AppEnvironmentName = 'local' | 'dev' | 'prod';

export interface AppEnvironment {
    name: AppEnvironmentName;
    production: boolean;
    /** API base URL including `/api` prefix (or relative `/api` for local proxy). */
    apiUrl: string;
    /** When true, domain services use in-memory mocks instead of HTTP */
    useMockApi: boolean;
    /**
     * When true, the sidebar "Viewing as" role switcher renders (demo-only — it real-logs-in
     * as canned demo accounts). MUST be false for any real production tenant.
     */
    demoRoleSwitcher: boolean;
    /**
     * CB-148 — gate the new Regimen & Order Set v2 screens (`/v2/...`). Off hides the routes entirely; the
     * old screens are unaffected either way. Remove once v2 replaces the old screens (later phase).
     */
    regimenOrderSetV2: boolean;
    /**
     * Internal EMR sandbox (Cerner FHIR R4 playground) at /settings/emr-sandbox. Local-only dev tool; off
     * hides the route + sidebar item entirely. The API has its own server-side gate (APP_ENV + flag), so this
     * is a UI convenience, not the security boundary.
     */
    emrSandbox: boolean;
}

/** Whether an outgoing HTTP request targets the Cyan Blue API (local proxy or absolute dev/prod URL). */
export function isCyanApiRequest(url: string, apiUrl: string): boolean {
    const normalized = apiUrl.replace(/\/$/, '');
    return url.startsWith('/api') || (normalized.length > 0 && url.startsWith(normalized));
}
